const style = {
  badgeStyle: {
    height: 23,
  }
}
export default style

